"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pgCronActions = void 0;
exports.pgCronActions = [
    {
        name: 'pgCron.task',
        path: '/execute',
        method: 'POST'
    },
];
